<template>
    <div style="text-align: center; width:530px; margin: 0 auto;font-family: 'Noto Sans KR', '맑은 고딕', 'Malgun Gothic', 'dotum';
    font-weight:bold;font-size: 15px;margin-top:12%;letter-spacing: -1px;color:#555;height:567px;">

    </div>
</template>

<script>
import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersKendoGridUtil from '@/common/kendo.grid.util'
import EtnersParseUtil from '@/common/etners.parse.util'
import EtnersDateTimeUtil from '@/common/etners.datetime.util'

export default {
  name: 'CheckDevice',
  mounted: function () {
    const router = this.$router

    const isMobile = function (currentDevice, pcDevice) {
      return currentDevice && pcDevice.indexOf(currentDevice.toLowerCase()) < 0
    }

    const redirectPageByDevice = function () {
      // PC용 플랫폼 나열
      const pcDevice = 'win16|win32|win64|mac|macintel'

      // 현재 접속한 디바이스 환경
      const currentDevice = navigator.platform

      const mobileTestFl = false

      let targetUrl
      let targetName
      let wmGbn

      if (isMobile(currentDevice, pcDevice) || mobileTestFl) {
        // 모바일 접속 환경
        targetUrl = '/m/login' // ex : http://dev-pcs.etnersplatform.com/m/login/
        targetName = 'MLogin'
        sessionStorage.setItem('displayMode', 'MOBILE')

      } else {
        // 웹 접속 환경
        targetUrl = '/login' // ex : http://dev-pcs.etnersplatform.com/login/
        targetName = 'Login'
        sessionStorage.setItem('displayMode', 'PC')
      }

      if(location.search.includes('?utopia=')) {
        let etnersUserId
        targetUrl += location.search
        etnersUserId = location.search.split('=')[1]
        router.push({path: targetUrl, params: {'utopia': etnersUserId}})

      }else if(location.search.includes('?loginUserToken=')){
        let loginUserToken
        targetUrl += location.search
        let queryParams = location.search.split('?')[1]

        let queryParamsArray = queryParams.split('&')

        let currentParams = {}

        for(let i=0; i < queryParamsArray.length; i++) {
          let queryKeyValue = queryParamsArray[i]

          let queryKey = queryKeyValue.split('=')[0]
          let queryValue = queryKeyValue.split('=')[1]

          currentParams[queryKey] = queryValue
        }

        router.push({ path : targetUrl, params : currentParams })

      }else{
        router.push({ path : targetUrl})
      }
    }

    redirectPageByDevice()
  }
}
</script>

<style scoped>

</style>
